import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  GetUploadsForDocumentQuery,
  GetUploadsForDocumentQueryVariables,
} from '#/graphql/generated';

export const GET_UPLOADS_FOR_DOCUMENT: TypedDocumentNode<
  GetUploadsForDocumentQuery,
  GetUploadsForDocumentQueryVariables
> = gql`
  query GetUploadsForDocument($documentId: ID!, $limit: Int) {
    uploadsForDocument(documentId: $documentId, limit: $limit) {
      id
      resourceId
      filename
      createdAt
      documentId
      documentPath
      url
      isEncrypted
      draft
    }
  }
`;
